"use strict";

exports.__esModule = true;
exports.showOverlayCheck20SelectPayment = exports.showCheck20 = exports.clickCheck20SelectPayment = exports.clickCheck20PreviousStep = exports.clickCheck20NextStep = exports.clickCheck20CustomerSupport = exports.clickCheck20ChangeProduct = exports.clickCheck20AddVoucherCode = void 0;

var _constants = require("../constants");

const eventLabel = (offer, type) => ({
  eventlabel: `subscriptionshop/payment?typeproduct=${offer}&typeflow=${type}`
});

const showCheck20 = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  ..._constants.show,
  ...(0, _constants.identityAccountId)(user)
});

exports.showCheck20 = showCheck20;

const clickCheck20AddVoucherCode = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  eventaction: `click-add-vouchercode`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCheck20AddVoucherCode = clickCheck20AddVoucherCode;

const clickCheck20SelectPayment = (user, offer, type, paymentType) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  eventaction: `click-${paymentType}`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCheck20SelectPayment = clickCheck20SelectPayment;

const showOverlayCheck20SelectPayment = (user, offer, type, paymentType) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  eventaction: `click-${paymentType}`,
  ...(0, _constants.identityAccountId)(user)
});

exports.showOverlayCheck20SelectPayment = showOverlayCheck20SelectPayment;

const clickCheck20ChangeProduct = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  ..._constants.changeProduct,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCheck20ChangeProduct = clickCheck20ChangeProduct;

const clickCheck20NextStep = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  eventaction: `click-confirm-payment`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCheck20NextStep = clickCheck20NextStep;

const clickCheck20PreviousStep = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  eventaction: `click-previous-step`,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCheck20PreviousStep = clickCheck20PreviousStep;

const clickCheck20CustomerSupport = (user, offer, type) => ({ ..._constants.eventBase,
  ...eventLabel(offer, type),
  ..._constants.conversionWall,
  ..._constants.customerSupport,
  ...(0, _constants.identityAccountId)(user)
});

exports.clickCheck20CustomerSupport = clickCheck20CustomerSupport;